import { render, staticRenderFns } from "./agregarTareas.vue?vue&type=template&id=0e098e80"
import script from "./agregarTareas.vue?vue&type=script&lang=js"
export * from "./agregarTareas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports